import http from '@/http'

// Sempre busca o schema atual — sem cache em memória nem HTTP — para refletir
// imediatamente qualquer edição feita no formulário de coleta de lead.
export const fetchLeadForm = async () => {
  const res = await http.get('/admin/check-in/lead-form', { params: { _t: Date.now() } })
  return res.data
}

export const fetchLeadSubmissions = async (participantId) => {
  const res = await http.get(`/admin/check-in/participants/${participantId}/lead-submissions`)
  return res.data && res.data.data ? res.data.data : []
}

export const saveLeadSubmission = async (participantId, data) => {
  const res = await http.post(`/admin/check-in/participants/${participantId}/lead-submissions`, { data })
  return res.data
}

export default { fetchLeadForm, fetchLeadSubmissions, saveLeadSubmission }
